import request from '@/plugin/axios'

export function getUsermanagementList(page) {
    return request({
        url: '/api/admin/organization',
        method: 'get',
        params: page
    })
}

export function getList(pageable) {
    return request({
        url: '/api/admin/user',
        method: 'get',
        params: pageable
    })
}

export function update(form) {
    return request({
        url: '/api/admin/user/'+form.id,
        method: 'put',
        params: form
    })
}

export function insertList(table) {
    return request({
        url: '/api/admin/user',
        method: 'post',
        params: table
    })
}

export function set(data) {
    return request({
        url: '/api/admin/queryRoleByUser',
        method: 'put',
        params: data
    })
}

export function queryOrgRoleList(data) {
    return request({
        url: '/api/admin/role',
        method: 'get',
        params: data
    })
}

export function setUserRole(data) {
    return request({
        url: '/api/admin/setUserRole',
        method: 'put',
        params: data
    })
}